// extracted by mini-css-extract-plugin
export var activityContainer = "_ll-0";
export var typingIndicatorContainer = "_ll-1";
export var typingIndicatorDot = "_ll-2";
export var wave = "_ll-3";